import {
  Box, CircularProgress, Container,
  Typography,
  useMediaQuery,
} from '@mui/material'
import { useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import CloseIcon from '@mui/icons-material/Close'
import InfoBox from '../../components/Cards/helpers/InfoBox'
import TitleWithBackBtn from '../../components/PageHelpers/TitleWithBackBtn'
import BatchStatus from '../../images/BatchStatus.svg'
import Success from '../../images/success.svg'
import ProcessedForCreation from '../../images/ProcessedForCreation.svg'
import FailedToCreate from '../../images/FailedToCreate.svg'
import TimeBox from '../../components/Cards/helpers/TimeBox'
import { getFormattedDateWithoutDay } from '../../utils/helpers'
import { selectImportUsersRolesDetails } from '../../redux/features/importUsersRolesDetails/importUsersRolesDetailsSlice'
import UseTranslation from '../../hooks/UseTranslation'
import { downloadFailedFile, filterImportUsersRolesDetailsList, retrieveImportUsersRolesDetailsByID, retrieveImportUsersRolesDetailsListByID, searchImportUsersRolesDetailsList } from '../../redux/features/importUsersRolesDetails/importUsersRolesDetailsThunk'
import TitleWithCountV2 from '../../components/PageHelpers/TitleWithCountV2'
import IconBtnV2 from '../../components/Buttons/IconBtnV2'
import FilterSort from '../../images/FilterSort.svg'
import SearchBarToggle from '../../components/PageHelpers/SearchBarToggle'
import ActiveFilters from '../../components/PageHelpers/ActiveFilters'
import EmployeeListContainer from './EmployeeListContainer'
import NoDataFound from '../../components/PageHelpers/NoDataFound'
import LoaderWithErrorHandler from '../../components/PageHelpers/LoaderWithErrorHandler'
import Loader from '../../components/helpers/Loader'
import { importUsersRolesResetAlertHandler } from '../../redux/features/importUsersRoles/importUsersRolesThunk'
import PageFilter from './PageFilter'
import { ReactComponent as ProcessedEmployees } from '../../images/RecordsSmallLargeYellow.svg'
import EmployeeListContainerSkeleton from './EmployeeListContainerSkeleton'
import OfoqThemeBtn from '../../components/Buttons/OfoqThemeBtn'

const Index = () => {
  const [searchBarExpanded, setSearchBarExpanded] = useState(false)
  const [openFilter, setOpenFilter] = useState(false)
  const isXsScreen = useMediaQuery((theme) => theme.breakpoints.only('xs'))
  const importUsersRoles = useSelector(selectImportUsersRolesDetails)
  const { id } = useParams()
  const dispatch = useDispatch()
  const { t } = UseTranslation()
  useEffect(() => {
    dispatch(retrieveImportUsersRolesDetailsByID({ queries: id }))
    dispatch(retrieveImportUsersRolesDetailsListByID({ queries: id }))
  }, [])
  const isFilteredArraysNotEmpty = importUsersRoles?.activeFilters?.length > 0
  const failedImportRoles = importUsersRoles?.importUsersRolesDetails?.fail_count > 0

  const downloadFailedImportRoles = () => {
    dispatch(downloadFailedFile({
      queries: {
        processId: id,
      },
    }))
  }
  return (
     <Container maxWidth="xl" sx={styles.container}>
      <TitleWithBackBtn
        title={
          <Box sx={styles.titleWithIcon}>
            <Box component={'img'} src={BatchStatus} alt='computerClockIcon' />
           {t?.['Import User\'s Roles']}
          </Box>
        }
        backBtnTxt={ isXsScreen ? '' : `${t?.back}`}
        customStyle={styles.header}
      />
       <Box sx={styles.statisticContainer}>
            <Box sx={styles.numbersContainer}>
          <InfoBox
                title={t?.Records}
                number={importUsersRoles?.RolesDetailsLoadingStatus ? <CircularProgress size="20px" /> : importUsersRoles?.importUsersRolesDetails?.all_count}
                color="#fbbd08"
                icon={<img src={ProcessedForCreation} alt="profile" />}
              subtitle={t?.['Processed for Importing']}
              />
          <InfoBox
                title={t?.Records}
                number={importUsersRoles?.RolesDetailsLoadingStatus ? <CircularProgress size="20px" /> : importUsersRoles?.importUsersRolesDetails?.success_count}
                color="#21ba45"
                icon={<img src={Success} alt="profile" />}
              subtitle={t?.['Imported Successfully']}
              />
          <InfoBox
                title={t?.Records}

                number={importUsersRoles?.RolesDetailsLoadingStatus ? <CircularProgress size="20px" /> : importUsersRoles?.importUsersRolesDetails?.fail_count}
                color="#db2828"
                icon={<img src={FailedToCreate} alt="profile" />}
              subtitle={t?.['Failed to Import']}
              />
            </Box>
              <TimeBox
            startDate={
              getFormattedDateWithoutDay(importUsersRoles?.importUsersRolesDetails?.start_date)}
            endDate={
              getFormattedDateWithoutDay(importUsersRoles?.importUsersRolesDetails?.end_date)}
            customStyle={styles.timeContainer}
            />
      </Box>
 <Box sx={styles.employeeContainer}>
        {!searchBarExpanded && (
          <Box sx={styles.titleWithDownload}>
              <TitleWithCountV2
            icon={<ProcessedEmployees />}
            iconSize='xl'
                store={importUsersRoles}
                title={t?.['Processed Records']}
                customStyle={styles.titleHeader}
            />
            {failedImportRoles && <OfoqThemeBtn
              name={<Typography>Failed Import Roles</Typography>}
              customStyle={styles.linkBtn}
              onClick={() => downloadFailedImportRoles()}
            />}
            </Box>
        )}
          <Box sx={styles.searchSortFilter}>
            <Box sx={isXsScreen && styles.filterWithSearch}>
            {(isXsScreen && !searchBarExpanded) && (
            <IconBtnV2
              icon={openFilter ? <CloseIcon /> : <img src={FilterSort} alt="filter icon" />}
              onClick={() => setOpenFilter(!openFilter)}
              customStyle={styles.xsFilterButton(isFilteredArraysNotEmpty)}
            />
            )}
            <SearchBarToggle
              searchPlaceholder={t?.['Search by E-Mail Address or Employee Code']}
              actionToDispatch={searchImportUsersRolesDetailsList}
              expandedState={searchBarExpanded}
                setExpandedState={setSearchBarExpanded}
               customStyle={styles.searchBar(searchBarExpanded)}
            />
          </Box>
            <Box sx={styles.sortFilter}>
              <PageFilter
                openModal={openFilter}
                setOpenModal={setOpenFilter}
              />
            </Box>
          </Box>
          {!isXsScreen && <ActiveFilters
            store={importUsersRoles}
            actionToDispatch={filterImportUsersRolesDetailsList}
            customStyle={styles.activeFilter}
          />}
      </Box>
        {failedImportRoles && <OfoqThemeBtn
              name={<Typography>Failed Import Roles</Typography>}
              customStyle={styles.xsLinkBtn}
              onClick={() => downloadFailedImportRoles()}
            />}
      <EmployeeListContainer store={importUsersRoles} customStyle={styles.employeeList} />
      <NoDataFound store={importUsersRoles} />
       <LoaderWithErrorHandler store={importUsersRoles}
        resetAlertHandler={importUsersRolesResetAlertHandler}
        Skeleton={EmployeeListContainerSkeleton}
        />
      <Loader store={importUsersRoles} />
      </Container>
  )
}

const styles = {
  container: {
    padding: { xs: '0px', sm: '0px 25px 0px 25px', md: ' 0px 52px !important' },
  },
  header: {
    height: { xs: '50px', sm: '90px' },
    padding: { xs: '15px 0px 0px', sm: '0px' },
    borderBottomLeftRadius: '15px',
    borderBottomRightRadius: '15px',
    margin: { xs: '-10px 10px 10px', sm: '-29px 0px 10px 0px', md: '-30px 0px 10px 0px' },
    '& > div': {
      marginTop: { xs: '5px', sm: '0px' },
      display: 'flex',
      flexDirection: { xs: 'row', sm: 'column' },
      alignItems: { xs: 'center', sm: 'unset' },
      px: { xs: '10px', sm: 'unset' },
    },
    '& .backBtn': {
      minWidth: '20px',
      m: { xs: '0 5px 0 0', sm: '5px 0' },
    },
    '& .container': {
      width: '100%',
    },
  },
  titleWithIcon: {
    ml: { xs: '-20px', sm: '30px' },
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    fontSize: { xs: '16px', sm: '24px' },
    '& img': {
      width: { xs: '22px', sm: '35px' },
      height: { xs: '22px', sm: '35px' },
      paddingRight: '5px',
    },
  },
  statisticContainer: {
    display: 'flex',
    flexDirection: { xs: 'row', sm: 'column' },
    justifyContent: { xs: 'space-around', sm: 'unset' },
  },
  numbersContainer: {
    height: { xs: '236px', sm: 'auto' },
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    justifyContent: { xs: 'space-around', sm: 'space-between' },
  },
  timeContainer: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    width: { xs: '50%', sm: '100%' },
    backgroundColor: '#fff',
    marginTop: { xs: '5px', sm: '10px' },
  },
  employeeContainer: {
    display: 'flex',
    flexDirection: { xs: 'row', sm: 'column' },
    alignItems: { xs: 'flex-end', sm: 'unset' },
    justifyContent: 'space-between',
    p: { xs: '10px 0 10px 0', sm: '10px 0' },
    margin: { xs: '0px 10px', sm: 'unset' },
  },
  titleHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginTop: '10px',
    marginBottom: { xs: '10px' },
    '& svg': {
      paddingRight: '10px',
    },
    '& span': {
      fontFamily: 'Avenir 85 light',
      fontWeight: 400,
      fontSize: { xs: '16px', sm: '18px' },
      lineHeight: { xs: '20.15px', sm: '37.08px' },
    },
    '& h5': {
      fontSize: { xs: '16px', sm: '24px' },
      fontWeight: 400,
      margin: '0',
    },
  },
  searchSortFilter: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    p: { xs: '0px 5px', sm: 'unset' },
  },
  sortFilter: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '20px',
  },
  filterWithSearch: {
    display: 'flex',
    gap: '5px',
    width: '100%',
    justifyContent: 'flex-end',
    '& img': {
      width: '15px',
      height: '15px',
    },
  },
  searchBar: (isFiltered) => ({
    height: '35px',
    width: isFiltered ? '100%' : '35px',
    marginBottom: { xs: '10px', sm: '0px' },
  }),
  xsFilterButton: (isFiltered) => ({
    height: '36px',
    width: '36px',
    borderRadius: '10px',
    border: isFiltered ? '1px solid #29CC8B' : '1px solid #e2e8ee',
    backgroundColor: 'white',
    color: 'text.hint',
    overflow: 'hidden',
    '& img': {
      filter: isFiltered && 'brightness(0) saturate(100%) invert(60%) sepia(98%) saturate(331%) hue-rotate(90deg) brightness(91%) contrast(91%)',
    },
  }),
  activeFilter: {
    marginBottom: { xs: '10px', sm: '5px' },
    marginTop: { xs: '5px', sm: '0px' },
  },
  employeeList: {
    width: '100%',
    marginBottom: { xs: '10px', sm: '20px' },
  },
  titleWithDownload: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '10px',
  },
  tipsTitleTextContainer: {
    position: { xs: 'absolute', md: 'static' },
    right: '0',
    top: '40px',
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    cursor: 'pointer',
    color: 'primary.main',
    '& span': {
      textDecoration: 'underline',
      marginBottom: '10px',
      width: 'max-content',
    },
  },
  linkBtn: {
    display: { xs: 'none', md: 'flex' },
    boxSizing: 'border-box',
    width: '100%',
    maxWidth: 'fit-content',
    minWidth: '140px',
    height: '40px',
    color: 'text.main',
    textTransform: 'none',
    mx: '0px',
    '& p': {
      fontSize: { xs: '12px', sm: '14px' },
      maxWidth: { xs: '196px', sm: '190px' },
      paddingLeft: { xs: '0px', sm: '0px' },
    },
  },
  xsLinkBtn: {
    maxWidth: '95% !important',
    minWidth: 'unset !important',
    display: { xs: 'flex', md: 'none' },
    p: { xs: '10px 0 10px 0', sm: '10px 0' },
    margin: { xs: '0px 10px', sm: 'unset' },
  },
}

export default Index
